import { useEffect, useState } from "react";
import { ProCard } from "@ant-design/pro-components";
import { Button, Table, Space, App } from "antd";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { getBuiltInUsers, updatePassword } from "@/apis/instance";
import { TopBreadcrumb } from "@/layouts/TopBreadcrumb";
import { useTranslation } from "react-i18next";

export const ChangeBuiltInPasswords = ({id, goto}) => {
  const { t } = useTranslation();
  const navigate = useResourceNavigate();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { modal } = App.useApp();
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setIsLoading(true);
        const response = await getBuiltInUsers(id);
        setIsLoading(false);
        setUsers(response.users || []);        
      } catch (error) {
        setIsLoading(false);
        setUsers([]);
        console.error("get built-in users failed:", error);
      }
    };

    fetchUsers();
  }, []);
  const doUpdatePwd = async (type, user) => {
      const response = await updatePassword(id, type, user);
      if (response.status === "OK") {
        modal.info({
          title: 'Password Updated',
          content: `The password of user ${user} is set to ${response.value}`,
        });
      } else {
        modal.warning({
          title: 'Error',
          content: `Faied to upadate password for user ${user}. ${response.message}`,
        });
      }         
  };
  
  const columns = [
    {
      title: "Type",
      dataIndex: "type"
    },
    {
      title: "User",
      dataIndex: "user"
    },
    {
      title: "Password",
      dataIndex: "password",
      render:(text, record) => <li>************<Button type="link" 
                                                   onClick={() => doUpdatePwd(record.type, record.user)}
                                           >Update</Button></li>
    }
  ];
  return (
    <div>
  <TopBreadcrumb />
  <ProCard split="vertical" style={{ marginTop: 20 }}>
    <ProCard title={<div style={{ fontSize: 18, fontWeight: 500}}>Built-in users</div>} headerBordered colSpan="100%">
        <Table columns={columns} dataSource={users} loading={isLoading} size="small" style={{minHeight:"230px"}}>

        </Table>
        <Space>
          <Button onClick={() => {
            navigate({ resource: goto, action: "list" });
          }}>Close</Button>
        </Space>
    </ProCard>
    </ProCard>
    </div>
  );
};